module.exports = __webpack_public_path__ + "img/camioneta.f6246929.png";